<script>
import TextEditor from '@/components/TextEditor.vue'
export default {
    components:{ TextEditor },
    props: ['model', 'prop', 'top','description', 'height', 'noToolbar', 'selectedHeaderStyle']
}
</script>
<template>
       <section v-if="model != null" style="" class="opacity-admin-bg" :style="{'top': top}">
        <div>{{ description }}</div>
            <TextEditor :model="model" :prop="prop" :noToolbar="noToolbar" :height="height == null ? '500px' : height" :selectedHeaderStyle="selectedHeaderStyle"></TextEditor>   
        </section>        
</template>

<style scoped>
    section{
        position: absolute;
        z-index:10; 
        left:-460px; 
        width: 460px;
        padding:20px 20px 45px 20px;
    }

    section div 
    {
        font-size: 13px;
        margin-bottom: 10px;
    }
</style>